import * as React from 'react';
import { Logout, Person, PlayArrow, People, Link as LinkIcon, Timeline } from '@mui/icons-material';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link, useLocation } from 'react-router-dom';
import { LOGOUT, PRIVATE, PRIVATE_ADMIN_PLAYERS, PRIVATE_ADMIN_USERS, PRIVATE_ADMIN_M3US, PRIVATE_ADMIN_PLAYER_HEALTH } from 'config/router/paths';


export function MainListItems() {
  const location = useLocation();
  return (
    <React.Fragment>
      <ListItemButton component={Link} to={PRIVATE_ADMIN_M3US} selected={location.pathname === PRIVATE_ADMIN_M3US}>
        <ListItemIcon sx={{ minWidth: 36 }}><LinkIcon fontSize="small" /></ListItemIcon>
        <ListItemText primary="Enlaces M3U" primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }} />
      </ListItemButton>
      <ListItemButton
        component={Link}
        to={PRIVATE_ADMIN_PLAYERS}
        selected={location.pathname === PRIVATE_ADMIN_PLAYERS}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <PlayArrow fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Reproducciones"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
        />
      </ListItemButton>
      <ListItemButton
        component={Link}
        to={PRIVATE_ADMIN_USERS}
        selected={location.pathname === PRIVATE_ADMIN_USERS}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <People fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Usuarios"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
        />
      </ListItemButton>
      <ListItemButton
        component={Link}
        to={PRIVATE_ADMIN_PLAYER_HEALTH}
        selected={location.pathname === PRIVATE_ADMIN_PLAYER_HEALTH}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Timeline fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Logs Player B"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
        />
      </ListItemButton>
    </React.Fragment>
  );
};

export function SecondaryListItems(){
  const location = useLocation();
  return (
    <React.Fragment>
      <ListItemButton
        component={Link}
        to={PRIVATE}
        selected={location.pathname.startsWith(PRIVATE) && !location.pathname.startsWith('/private/admin')}
      >
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Person fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Vista Usuario"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500 }}
        />
      </ListItemButton>
      <ListItemButton component={Link} to={LOGOUT}>
        <ListItemIcon sx={{ minWidth: 36 }}>
          <Logout fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primary="Cerrar Sesión"
          primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: 500, color: 'error.main' }}
        />
      </ListItemButton>
    </React.Fragment>
  );
};
